export default class LabelValuePair<TLabel, TValue> {
	constructor(data?: any) {
		if (data) {
			this.label = data.label;
			this.value = data.value;
		}
	}

	label!: TLabel;
	value!: TValue;
}